import _ from 'lodash'

export const managedQueryParameters = {
  created() {
    this.initialQueryParameters = this.queryParameters()
  },

  data() {
    return {
      initialQueryParameters: null
    }
  },

  methods: {
    updateQueryParameters(changes) {
      this.$router.replace(
        Object.assign({}, this.$route, { query: _.pickBy({ ...this.queryParameters(), ...changes }) })
      )
    },

    queryParameters() {
      let queryString = decodeURI(window.location.search) || ''
      queryString = queryString.substr(1)
      let keyValPairs = []
      let queryParameters = {}

      if (queryString.length) {
        keyValPairs = queryString.split('&')
        keyValPairs.forEach(pair => {
          let [key, value] = pair.split('=')
          if (key && !queryParameters[key]) {
            queryParameters[key] = []
          }
          if (key && queryParameters[key]) {
            queryParameters[key] = _.union(queryParameters[key], [value])
          }
        })
      }

      return queryParameters
    }
  }
}

export default {
  managedQueryParameters
}
